import styled from 'styled-components';

import { CONTAINER_MAX } from '@/constants/breakpoints';

export const ContentWrapper = styled.div`
  overflow-y: scroll;
  @media (max-width: ${CONTAINER_MAX.tablet}) {
    height: 100%;
  }

  background-color: inherit;

  & [data-open='true'] {
    background-color: var(--bg-card);
  }

  &::-webkit-scrollbar {
    background-color: transparent;
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    width: 4px;
    height: 59px;
    border-radius: 7px;
    background-color: #b1b8c6;
  }

  will-change: height;
`;
